// Product data for HyperCore store
// Updated with correct image extensions

export const products = {
  gpus: {
    title: "Graphics Cards",
    budget: [
      {
        id: 'gpu-1',
        name: 'GIGABYTE Radeon RX 9060 XT Gaming OC 16GB',
        priceUSD: 359.99,
        priceEUR: 307.97,
        supply: 7,
        imageUrl: '/images/gpus/gpu-1.webp',
        specs: {
          'Memory': '16GB GDDR6',
          'Memory Interface': '256-bit',
          'Core Clock': 'Boost Clock up to 2565 MHz',
          'Stream Processors': '3584',
          'Power Connectors': '2x 8-pin',
          'TDP': '220W',
          'Outputs': '3x DisplayPort 2.1, 1x HDMI 2.1',
          'Cooling': 'WINDFORCE 3X Cooling System'
        }
      },
      {
        id: 'gpu-2',
        name: 'Gigabyte GeForce RTX 3050 8GB',
        priceUSD: 199.99,
        priceEUR: 171.09,
        supply: 21,
        imageUrl: '/images/gpus/gpu-2.avif',
        specs: {
          'Memory': '8GB GDDR6',
          'Memory Interface': '128-bit',
          'Boost Clock': '1807 MHz',
          'CUDA Cores': '2560',
          'Power Connectors': '1x 8-pin',
          'TDP': '130W',
          'Outputs': '2x DisplayPort 1.4a, 2x HDMI 2.1',
          'Ray Tracing': 'RT Cores 2nd Gen',
          'DLSS': 'DLSS 2.0'
        }
      },
      {
        id: 'gpu-3',
        name: 'Sapphire PULSE Radeon RX 6600 8GB',
        priceUSD: 184.99,
        priceEUR: 158.26,
        supply: 19,
        imageUrl: '/images/gpus/gpu-3.webp',
        specs: {
          'Memory': '8GB GDDR6',
          'Memory Interface': '128-bit',
          'Game Clock': '2491 MHz',
          'Boost Clock': '2589 MHz',
          'Stream Processors': '1792',
          'Power Connectors': '1x 8-pin',
          'TDP': '132W',
          'Outputs': '1x DisplayPort 1.4, 1x HDMI 2.1'
        }
      },
      {
        id: 'gpu-4',
        name: 'Sapphire Pulse Radeon RX 7600 8GB',
        priceUSD: 244.99,
        priceEUR: 209.59,
        supply: 17,
        imageUrl: '/images/gpus/gpu-4.avif',
        specs: {
          'Memory': '8GB GDDR6',
          'Memory Interface': '128-bit',
          'Game Clock': '2250 MHz',
          'Boost Clock': '2655 MHz',
          'Stream Processors': '2048',
          'Power Connectors': '1x 8-pin',
          'TDP': '165W',
          'Outputs': '2x DisplayPort 2.1, 1x HDMI 2.1',
          'Architecture': 'RDNA 3'
        }
      },
      {
        id: 'gpu-5',
        name: 'ZOTAC Geforce RTX 5050 TWIN EDGE OC 8GB',
        priceUSD: 254.99,
        priceEUR: 218.14,
        supply: 11,
        imageUrl: '/images/gpus/gpu-5.jpg',
        specs: {
          'Memory': '8GB GDDR7',
          'Memory Interface': '128-bit',
          'Boost Clock': '2850 MHz',
          'CUDA Cores': '3072',
          'Power Connectors': '1x 12VHPWR (8-pin adapter included)',
          'TDP': '140W',
          'Outputs': '3x DisplayPort 2.1a, 1x HDMI 2.1',
          'Ray Tracing': 'RT Cores 5th Gen',
          'DLSS': 'DLSS 4.0'
        }
      }
    ],
    performance: [
      {
        id: 'gpu-6',
        name: 'GAINWARD GeForce RTX 5090 Phantom 32G',
        priceUSD: 2299.99,
        priceEUR: 1967.64,
        supply: 2,
        imageUrl: '/images/gpus/gpu-6.webp',
        specs: {
          'Memory': '32GB GDDR7',
          'Memory Interface': '512-bit',
          'Boost Clock': '2715 MHz',
          'CUDA Cores': '21760',
          'Power Connectors': '1x 12V-2x6 (600W)',
          'TDP': '575W',
          'Outputs': '3x DisplayPort 2.1a, 1x HDMI 2.1',
          'Ray Tracing': 'RT Cores 5th Gen',
          'DLSS': 'DLSS 4.0',
          'Cooling': 'Triple-fan Phantom Cooling'
        }
      },
      {
        id: 'gpu-7',
        name: 'GAINWARD GeForce RTX 5080 Phoenix 16G',
        priceUSD: 1049.99,
        priceEUR: 898.27,
        supply: 4,
        imageUrl: '/images/gpus/gpu-7.webp',
        specs: {
          'Memory': '16GB GDDR7',
          'Memory Interface': '256-bit',
          'Boost Clock': '2850 MHz',
          'CUDA Cores': '10752',
          'Power Connectors': '1x 12V-2x6 (450W)',
          'TDP': '360W',
          'Outputs': '3x DisplayPort 2.1a, 1x HDMI 2.1',
          'Ray Tracing': 'RT Cores 5th Gen',
          'DLSS': 'DLSS 4.0',
          'Cooling': 'Phoenix Tri-Fan Design'
        }
      },
      {
        id: 'gpu-8',
        name: 'Gigabyte GeForce RTX 4080 Super WINDFORCE V2 16G',
        priceUSD: 979.99,
        priceEUR: 838.38,
        supply: 5,
        imageUrl: '/images/gpus/gpu-8.webp',
        specs: {
          'Memory': '16GB GDDR6X',
          'Memory Interface': '256-bit',
          'Boost Clock': '2595 MHz',
          'CUDA Cores': '10240',
          'Power Connectors': '1x 12VHPWR (450W)',
          'TDP': '320W',
          'Outputs': '3x DisplayPort 1.4a, 1x HDMI 2.1',
          'Ray Tracing': 'RT Cores 3rd Gen',
          'DLSS': 'DLSS 3.5'
        }
      },
      {
        id: 'gpu-9',
        name: 'MSI GeForce RTX 5070 Ti 16G VENTUS 3X OC',
        priceUSD: 769.99,
        priceEUR: 658.73,
        supply: 18,
        imageUrl: '/images/gpus/gpu-9.webp',
        specs: {
          'Memory': '16GB GDDR7',
          'Memory Interface': '256-bit',
          'Boost Clock': '2745 MHz',
          'CUDA Cores': '8960',
          'Power Connectors': '1x 12V-2x6 (300W)',
          'TDP': '285W',
          'Outputs': '3x DisplayPort 2.1a, 1x HDMI 2.1',
          'Ray Tracing': 'RT Cores 5th Gen',
          'DLSS': 'DLSS 4.0',
          'Cooling': 'TORX Fan 4.0'
        }
      },
      {
        id: 'gpu-10',
        name: 'ASRock Radeon RX 9070 XT Taichi 16GB OC',
        priceUSD: 679.99,
        priceEUR: 581.73,
        supply: 0,
        imageUrl: '/images/gpus/gpu-10.webp',
        specs: {
          'Memory': '16GB GDDR6',
          'Memory Interface': '256-bit',
          'Game Clock': '2450 MHz',
          'Boost Clock': '2880 MHz',
          'Stream Processors': '4096',
          'Power Connectors': '2x 8-pin',
          'TDP': '295W',
          'Outputs': '3x DisplayPort 2.1, 1x HDMI 2.1',
          'Architecture': 'RDNA 4',
          'Cooling': 'Taichi Triple Fan'
        }
      },
      {
        id: 'gpu-11',
        name: 'Sapphire Nitro + Radeon RX 7800 XT 16GB',
        priceUSD: 489.99,
        priceEUR: 419.19,
        supply: 6,
        imageUrl: '/images/gpus/gpu-11.webp',
        specs: {
          'Memory': '16GB GDDR6',
          'Memory Interface': '256-bit',
          'Game Clock': '2254 MHz',
          'Boost Clock': '2565 MHz',
          'Stream Processors': '3840',
          'Power Connectors': '2x 8-pin',
          'TDP': '263W',
          'Outputs': '2x DisplayPort 2.1, 2x HDMI 2.1',
          'Architecture': 'RDNA 3',
          'Cooling': 'Tri-X Cooling Technology'
        }
      },
      {
        id: 'gpu-12',
        name: 'ASUS Prime GeForce RTX 5070 12GB',
        priceUSD: 559.99,
        priceEUR: 479.07,
        supply: 11,
        imageUrl: '/images/gpus/gpu-12.avif',
        specs: {
          'Memory': '12GB GDDR7',
          'Memory Interface': '192-bit',
          'Boost Clock': '2610 MHz',
          'CUDA Cores': '6144',
          'Power Connectors': '1x 12V-2x6 (220W)',
          'TDP': '220W',
          'Outputs': '3x DisplayPort 2.1a, 1x HDMI 2.1',
          'Ray Tracing': 'RT Cores 5th Gen',
          'DLSS': 'DLSS 4.0',
          'Cooling': 'Axial-tech Fan Design'
        }
      }
    ]
  },
  cpus: {
    title: "Processors",
    budget: [
      {
        id: 'cpu-1',
        name: 'Intel Core i5-12400F',
        priceUSD: 99.99,
        priceEUR: 85.54,
        supply: 13,
        imageUrl: '/images/cpus/cpu-1.webp',
        specs: {
          'Cores': '6',
          'Threads': '12',
          'Base Clock': '2.5 GHz',
          'Boost Clock': '4.4 GHz',
          'Cache': '18MB Intel Smart Cache',
          'TDP': '65W',
          'Max TDP': '117W',
          'Socket': 'LGA1700',
          'Memory Support': 'DDR4-3200, DDR5-4800',
          'Integrated Graphics': 'None (F-series)'
        }
      },
      {
        id: 'cpu-2',
        name: 'AMD Ryzen 5 8400F',
        priceUSD: 124.99,
        priceEUR: 106.93,
        supply: 20,
        imageUrl: '/images/cpus/cpu-2.webp',
        specs: {
          'Cores': '6',
          'Threads': '12',
          'Base Clock': '4.2 GHz',
          'Boost Clock': '4.7 GHz',
          'Cache': '22MB (L2+L3)',
          'TDP': '65W',
          'Socket': 'AM5',
          'Memory Support': 'DDR5-5200',
          'Architecture': 'Zen 4',
          'Integrated Graphics': 'None (F-series)'
        }
      },
      {
        id: 'cpu-3',
        name: 'AMD Ryzen 5 5600X',
        priceUSD: 119.99,
        priceEUR: 102.65,
        supply: 23,
        imageUrl: '/images/cpus/cpu-3.avif',
        specs: {
          'Cores': '6',
          'Threads': '12',
          'Base Clock': '3.7 GHz',
          'Boost Clock': '4.6 GHz',
          'Cache': '35MB (L2+L3)',
          'TDP': '65W',
          'Socket': 'AM4',
          'Memory Support': 'DDR4-3200',
          'Architecture': 'Zen 3',
          'Integrated Graphics': 'None'
        }
      },
      {
        id: 'cpu-4',
        name: 'AMD Ryzen 5 5600',
        priceUSD: 104.99,
        priceEUR: 89.82,
        supply: 16,
        imageUrl: '/images/cpus/cpu-4.webp',
        specs: {
          'Cores': '6',
          'Threads': '12',
          'Base Clock': '3.5 GHz',
          'Boost Clock': '4.4 GHz',
          'Cache': '35MB (L2+L3)',
          'TDP': '65W',
          'Socket': 'AM4',
          'Memory Support': 'DDR4-3200',
          'Architecture': 'Zen 3',
          'Integrated Graphics': 'None'
        }
      },
      {
        id: 'cpu-5',
        name: 'Intel Core i3-13100F',
        priceUSD: 89.99,
        priceEUR: 76.99,
        supply: 22,
        imageUrl: '/images/cpus/cpu-5.avif',
        specs: {
          'Cores': '4',
          'Threads': '8',
          'P-Core Base': '3.4 GHz',
          'P-Core Boost': '4.5 GHz',
          'Cache': '12MB Intel Smart Cache',
          'TDP': '58W',
          'Max TDP': '110W',
          'Socket': 'LGA1700',
          'Memory Support': 'DDR4-3200, DDR5-4800',
          'Integrated Graphics': 'None (F-series)'
        }
      }
    ],
    performance: [
      {
        id: 'cpu-6',
        name: 'AMD Ryzen 9 9950X3D',
        priceUSD: 649.99,
        priceEUR: 556.07,
        supply: 4,
        imageUrl: '/images/cpus/cpu-6.webp',
        specs: {
          'Cores': '16',
          'Threads': '32',
          'Base Clock': '4.3 GHz',
          'Boost Clock': '5.7 GHz',
          'Cache': '144MB (L2+L3)',
          '3D V-Cache': '128MB',
          'TDP': '120W',
          'Socket': 'AM5',
          'Memory Support': 'DDR5-5600',
          'Architecture': 'Zen 5',
          'Integrated Graphics': 'Radeon Graphics'
        }
      },
      {
        id: 'cpu-7',
        name: 'AMD Ryzen 9 9900X3D',
        priceUSD: 549.99,
        priceEUR: 470.52,
        supply: 3,
        imageUrl: '/images/cpus/cpu-7.webp',
        specs: {
          'Cores': '12',
          'Threads': '24',
          'Base Clock': '4.4 GHz',
          'Boost Clock': '5.5 GHz',
          'Cache': '140MB (L2+L3)',
          '3D V-Cache': '128MB',
          'TDP': '120W',
          'Socket': 'AM5',
          'Memory Support': 'DDR5-5600',
          'Architecture': 'Zen 5',
          'Integrated Graphics': 'Radeon Graphics'
        }
      },
      {
        id: 'cpu-8',
        name: 'Intel Core Ultra 9 285K',
        priceUSD: 519.99,
        priceEUR: 444.85,
        supply: 7,
        imageUrl: '/images/cpus/cpu-8.webp',
        specs: {
          'Cores': '24 (8P + 16E)',
          'Threads': '24',
          'P-Core Base': '3.7 GHz',
          'P-Core Boost': '5.7 GHz',
          'E-Core Base': '3.2 GHz',
          'E-Core Boost': '4.6 GHz',
          'Cache': '36MB Intel Smart Cache',
          'TDP': '125W',
          'Max TDP': '250W',
          'Socket': 'LGA1851',
          'Memory Support': 'DDR5-6400'
        }
      },
      {
        id: 'cpu-9',
        name: 'Intel Core i9-14900KF',
        priceUSD: 409.99,
        priceEUR: 350.75,
        supply: 6,
        imageUrl: '/images/cpus/cpu-9.webp',
        specs: {
          'Cores': '24 (8P + 16E)',
          'Threads': '32',
          'P-Core Base': '3.2 GHz',
          'P-Core Boost': '6.0 GHz',
          'E-Core Base': '2.4 GHz',
          'E-Core Boost': '4.4 GHz',
          'Cache': '36MB Intel Smart Cache',
          'TDP': '125W',
          'Max TDP': '253W',
          'Socket': 'LGA1700',
          'Memory Support': 'DDR4-3200, DDR5-5600',
          'Integrated Graphics': 'None (KF-series)'
        }
      },
      {
        id: 'cpu-10',
        name: 'AMD Ryzen 9 7950X',
        priceUSD: 419.99,
        priceEUR: 359.30,
        supply: 10,
        imageUrl: '/images/cpus/cpu-10.avif',
        specs: {
          'Cores': '16',
          'Threads': '32',
          'Base Clock': '4.5 GHz',
          'Boost Clock': '5.7 GHz',
          'Cache': '80MB (L2+L3)',
          'TDP': '170W',
          'Socket': 'AM5',
          'Memory Support': 'DDR5-5200',
          'Architecture': 'Zen 4',
          'Integrated Graphics': 'Radeon Graphics'
        }
      },
      {
        id: 'cpu-11',
        name: 'AMD Ryzen 7 9800X3D',
        priceUSD: 459.99,
        priceEUR: 393.52,
        supply: 14,
        imageUrl: '/images/cpus/cpu-11.webp',
        specs: {
          'Cores': '8',
          'Threads': '16',
          'Base Clock': '4.7 GHz',
          'Boost Clock': '5.2 GHz',
          'Cache': '104MB (L2+L3)',
          '3D V-Cache': '96MB',
          'TDP': '120W',
          'Socket': 'AM5',
          'Memory Support': 'DDR5-5600',
          'Architecture': 'Zen 5',
          'Integrated Graphics': 'Radeon Graphics'
        }
      },
      {
        id: 'cpu-12',
        name: 'Intel Core i7-14700K',
        priceUSD: 319.99,
        priceEUR: 273.75,
        supply: 0,
        imageUrl: '/images/cpus/cpu-12.webp',
        specs: {
          'Cores': '20 (8P + 12E)',
          'Threads': '28',
          'P-Core Base': '3.4 GHz',
          'P-Core Boost': '5.6 GHz',
          'E-Core Base': '2.5 GHz',
          'E-Core Boost': '4.3 GHz',
          'Cache': '33MB Intel Smart Cache',
          'TDP': '125W',
          'Max TDP': '253W',
          'Socket': 'LGA1700',
          'Memory Support': 'DDR4-3200, DDR5-5600',
          'Integrated Graphics': 'Intel UHD Graphics 770'
        }
      }
    ]
  },
  ssds: {
    title: "Solid State Drives",
    budget: [
      {
        id: 'ssd-1',
        name: 'Crucial P310 500GB PCIe 4.0 NVMe',
        priceUSD: 59.99,
        priceEUR: 51.32,
        supply: 13,
        imageUrl: '/images/ssds/ssd-1.webp',
        specs: {
          'Capacity': '500GB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,100 MB/s',
          'Sequential Write': 'Up to 6,000 MB/s',
          'TBW': '110 TB',
          'NAND Type': '3D QLC'
        }
      },
      {
        id: 'ssd-2',
        name: 'Kingston NV3 500GB PCIe 4.0 NVMe',
        priceUSD: 64.99,
        priceEUR: 55.60,
        supply: 0,
        imageUrl: '/images/ssds/ssd-2.jpg',
        specs: {
          'Capacity': '500GB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 6,000 MB/s',
          'Sequential Write': 'Up to 5,000 MB/s',
          'TBW': '160 TB',
          'NAND Type': '3D TLC'
        }
      },
      {
        id: 'ssd-3',
        name: 'Patriot VP4300L 500GB PCIe 4.0 NVMe',
        priceUSD: 69.99,
        priceEUR: 59.88,
        supply: 5,
        imageUrl: '/images/ssds/ssd-3.jpg',
        specs: {
          'Capacity': '500GB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,400 MB/s',
          'Sequential Write': 'Up to 6,800 MB/s',
          'TBW': '400 TB',
          'NAND Type': '3D TLC'
        }
      },
      {
        id: 'ssd-4',
        name: 'WD Blue SN5100 1TB PCIe 4.0 NVMe',
        priceUSD: 104.99,
        priceEUR: 89.82,
        supply: 3,
        imageUrl: '/images/ssds/ssd-4.webp',
        specs: {
          'Capacity': '1TB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 5,500 MB/s',
          'Sequential Write': 'Up to 5,000 MB/s',
          'TBW': '600 TB',
          'Warranty': '5 Years'
        }
      },
      {
        id: 'ssd-5',
        name: 'Patriot Viper VP4300 Lite 1TB PCIe 4.0 NVMe',
        priceUSD: 109.99,
        priceEUR: 94.10,
        supply: 6,
        imageUrl: '/images/ssds/ssd-5.jpg',
        specs: {
          'Capacity': '1TB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,400 MB/s',
          'Sequential Write': 'Up to 6,800 MB/s',
          'TBW': '800 TB',
          'Heatsink': 'Included'
        }
      }
    ],
    mainstream: [
      {
        id: 'ssd-6',
        name: 'WD Blue SN5000 500GB PCIe 4.0 NVMe',
        priceUSD: 67.99,
        priceEUR: 58.17,
        supply: 0,
        imageUrl: '/images/ssds/ssd-6.webp',
        specs: {
          'Capacity': '500GB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 5,500 MB/s',
          'Sequential Write': 'Up to 4,500 MB/s',
          'TBW': '300 TB',
          'Warranty': '5 Years'
        }
      },
      {
        id: 'ssd-7',
        name: 'Crucial T500 1TB PCIe 4.0 NVMe',
        priceUSD: 119.99,
        priceEUR: 102.65,
        supply: 1,
        imageUrl: '/images/ssds/ssd-7.webp',
        specs: {
          'Capacity': '1TB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,400 MB/s',
          'Sequential Write': 'Up to 7,000 MB/s',
          'TBW': '600 TB',
          'DRAM Cache': 'Yes'
        }
      },
      {
        id: 'ssd-8',
        name: 'Samsung 990 PRO 1TB PCIe 4.0 NVMe',
        priceUSD: 149.99,
        priceEUR: 128.32,
        supply: 8,
        imageUrl: '/images/ssds/ssd-8.jpg',
        specs: {
          'Capacity': '1TB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,450 MB/s',
          'Sequential Write': 'Up to 6,900 MB/s',
          'TBW': '600 TB',
          'NAND Type': 'Samsung V-NAND'
        }
      },
      {
        id: 'ssd-9',
        name: 'Lexar NM790 1TB PCIe 4.0 NVMe',
        priceUSD: 124.99,
        priceEUR: 106.93,
        supply: 7,
        imageUrl: '/images/ssds/ssd-9.jpg',
        specs: {
          'Capacity': '1TB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,400 MB/s',
          'Sequential Write': 'Up to 6,500 MB/s',
          'TBW': '1000 TB',
          'DRAM Cache': 'Yes'
        }
      },
      {
        id: 'ssd-10',
        name: 'Samsung 990 EVO Plus 2TB PCIe 4.0 NVMe',
        priceUSD: 224.99,
        priceEUR: 192.48,
        supply: 2,
        imageUrl: '/images/ssds/ssd-10.webp',
        specs: {
          'Capacity': '2TB',
          'Interface': 'PCIe 4.0 x4 / PCIe 5.0 x2',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,250 MB/s',
          'Sequential Write': 'Up to 6,300 MB/s',
          'TBW': '1200 TB',
          'NAND Type': 'Samsung V-NAND'
        }
      },
      {
        id: 'ssd-11',
        name: 'WD SN7100 2TB PCIe 5.0 NVMe',
        priceUSD: 264.99,
        priceEUR: 226.70,
        supply: 5,
        imageUrl: '/images/ssds/ssd-11.webp',
        specs: {
          'Capacity': '2TB',
          'Interface': 'PCIe 5.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 12,500 MB/s',
          'Sequential Write': 'Up to 11,000 MB/s',
          'TBW': '1200 TB',
          'Heatsink': 'Included'
        }
      },
      {
        id: 'ssd-12',
        name: 'WD_BLACK SN850X 2TB PCIe 4.0 NVMe',
        priceUSD: 239.99,
        priceEUR: 205.31,
        supply: 5,
        imageUrl: '/images/ssds/ssd-12.jpg',
        specs: {
          'Capacity': '2TB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,300 MB/s',
          'Sequential Write': 'Up to 6,600 MB/s',
          'TBW': '1200 TB',
          'Game Mode 2.0': 'Yes'
        }
      },
      {
        id: 'ssd-13',
        name: 'Silicon Power US75 4TB PCIe 4.0 NVMe',
        priceUSD: 389.99,
        priceEUR: 333.64,
        supply: 0,
        imageUrl: '/images/ssds/ssd-13.jpg',
        specs: {
          'Capacity': '4TB',
          'Interface': 'PCIe 4.0 x4 NVMe',
          'Form Factor': 'M.2 2280',
          'Sequential Read': 'Up to 7,300 MB/s',
          'Sequential Write': 'Up to 6,800 MB/s',
          'TBW': '3000 TB',
          'DRAM Cache': 'Yes'
        }
      }
    ]
  },
  monitors: {
    title: "Monitors",
    va: [
      {
        id: 'mon-1',
        name: 'Samsung Odyssey G3 24"',
        priceUSD: 119.99,
        priceEUR: 102.65,
        supply: 16,
        imageUrl: '/images/monitors/mon-1.webp',
        specs: {
          'Screen Size': '24"',
          'Panel Type': 'VA',
          'Resolution': '1920 x 1080 (Full HD)',
          'Refresh Rate': '180Hz',
          'Response Time': '1ms (MPRT)',
          'Brightness': '250 cd/m²',
          'Contrast Ratio': '3000:1',
          'FreeSync': 'Yes'
        }
      },
      {
        id: 'mon-2',
        name: 'MSI MAG 244C 23.6"',
        priceUSD: 129.99,
        priceEUR: 111.21,
        supply: 9,
        imageUrl: '/images/monitors/mon-2.webp',
        specs: {
          'Screen Size': '23.6"',
          'Panel Type': 'VA Curved (1500R)',
          'Resolution': '1920 x 1080 (Full HD)',
          'Refresh Rate': '180Hz',
          'Response Time': '1ms (MPRT)',
          'Brightness': '250 cd/m²',
          'FreeSync Premium': 'Yes'
        }
      },
      {
        id: 'mon-3',
        name: 'ASUS ROG Strix XG27WCS',
        priceUSD: 219.99,
        priceEUR: 188.20,
        supply: 20,
        imageUrl: '/images/monitors/mon-3.webp',
        specs: {
          'Screen Size': '27"',
          'Panel Type': 'VA Curved (1500R)',
          'Resolution': '2560 x 1440 (QHD)',
          'Refresh Rate': '180Hz',
          'Response Time': '1ms (GTG)',
          'Brightness': '300 cd/m²',
          'HDR': 'HDR10'
        }
      },
      {
        id: 'mon-4',
        name: 'AOC MiniLED Q27G3XMN',
        priceUSD: 264.99,
        priceEUR: 226.70,
        supply: 11,
        imageUrl: '/images/monitors/mon-4.jpg',
        specs: {
          'Screen Size': '27"',
          'Panel Type': 'VA MiniLED',
          'Resolution': '2560 x 1440 (QHD)',
          'Refresh Rate': '180Hz',
          'Response Time': '1ms (MPRT)',
          'HDR': 'HDR1000',
          'Local Dimming Zones': '336 zones'
        }
      },
      {
        id: 'mon-5',
        name: 'ASUS ROG Strix XG27WCMS',
        priceUSD: 329.99,
        priceEUR: 282.31,
        supply: 6,
        imageUrl: '/images/monitors/mon-5.avif',
        specs: {
          'Screen Size': '27"',
          'Panel Type': 'VA Curved (1500R)',
          'Resolution': '2560 x 1440 (QHD)',
          'Refresh Rate': '240Hz',
          'Response Time': '0.5ms (GTG)',
          'HDR': 'HDR600'
        }
      },
      {
        id: 'mon-6',
        name: 'MSI MAG 321CUPDF',
        priceUSD: 439.99,
        priceEUR: 376.41,
        supply: 3,
        imageUrl: '/images/monitors/mon-6.jpg',
        specs: {
          'Screen Size': '32"',
          'Panel Type': 'VA Curved (1500R)',
          'Resolution': '3840 x 2160 (4K UHD)',
          'Refresh Rate': '160Hz',
          'Response Time': '1ms (MPRT)',
          'HDR': 'HDR600',
          'USB-C': '65W Power Delivery'
        }
      }
    ],
    oled: [
      {
        id: 'mon-7',
        name: 'AOC AG276QZD2',
        priceUSD: 299.99,
        priceEUR: 256.64,
        supply: 0,
        imageUrl: '/images/monitors/mon-7.jpg',
        specs: {
          'Screen Size': '27"',
          'Panel Type': 'OLED (QD-OLED)',
          'Resolution': '2560 x 1440 (QHD)',
          'Refresh Rate': '240Hz',
          'Response Time': '0.03ms (GTG)',
          'HDR': 'HDR True Black 400',
          'Color Gamut': '99% DCI-P3'
        }
      },
      {
        id: 'mon-8',
        name: 'LG UltraGear 27GX704A-B',
        priceUSD: 379.99,
        priceEUR: 325.08,
        supply: 8,
        imageUrl: '/images/monitors/mon-8.webp',
        specs: {
          'Screen Size': '27"',
          'Panel Type': 'OLED (W-OLED)',
          'Resolution': '2560 x 1440 (QHD)',
          'Refresh Rate': '240Hz',
          'Response Time': '0.03ms (GTG)',
          'HDR': 'HDR True Black 400',
          'Color Gamut': '99% DCI-P3'
        }
      },
      {
        id: 'mon-9',
        name: 'Samsung Odyssey OLED G6 G60SD',
        priceUSD: 499.99,
        priceEUR: 427.74,
        supply: 4,
        imageUrl: '/images/monitors/mon-9.webp',
        specs: {
          'Screen Size': '27"',
          'Panel Type': 'OLED (QD-OLED)',
          'Resolution': '2560 x 1440 (QHD)',
          'Refresh Rate': '360Hz',
          'Response Time': '0.03ms (GTG)',
          'HDR': 'HDR True Black 400',
          'Smart TV Features': 'Yes (Tizen)'
        }
      },
      {
        id: 'mon-10',
        name: 'AOC AGON AG326UD',
        priceUSD: 649.99,
        priceEUR: 556.07,
        supply: 4,
        imageUrl: '/images/monitors/mon-10.webp',
        specs: {
          'Screen Size': '31.5"',
          'Panel Type': 'OLED (QD-OLED)',
          'Resolution': '3840 x 2160 (4K UHD)',
          'Refresh Rate': '240Hz',
          'Response Time': '0.03ms (GTG)',
          'HDR': 'HDR True Black 400',
          'USB-C': '90W Power Delivery'
        }
      },
      {
        id: 'mon-11',
        name: 'ASUS ROG Swift PG32UCDP',
        priceUSD: 829.99,
        priceEUR: 710.06,
        supply: 6,
        imageUrl: '/images/monitors/mon-11.jpg',
        specs: {
          'Screen Size': '32"',
          'Panel Type': 'OLED (QD-OLED)',
          'Resolution': '3840 x 2160 (4K UHD)',
          'Refresh Rate': '240Hz',
          'Response Time': '0.03ms (GTG)',
          'HDR': 'HDR True Black 400',
          'Dual Mode': '4K 240Hz / 1080p 480Hz'
        }
      }
    ]
  },
  ram: {
    title: "Memory (RAM)",
    ddr4: [
      {
        id: 'ram-1',
        name: 'Kingston FURY Beast RGB 8GB',
        priceUSD: 59.99,
        priceEUR: 51.32,
        supply: 0,
        imageUrl: '/images/ram/ram-1.webp',
        specs: {
          'Type': 'DDR4',
          'Configuration': 'Single (1x8GB)',
          'Total Capacity': '8GB',
          'Speed': '3200MHz',
          'CAS Latency': 'CL16',
          'RGB': 'Yes (Infrared Sync)',
          'XMP': 'Intel XMP Ready'
        }
      },
      {
        id: 'ram-2',
        name: 'Kingston FURY Beast 16GB Kit',
        priceUSD: 99.99,
        priceEUR: 85.54,
        supply: 4,
        imageUrl: '/images/ram/ram-2.jpg',
        specs: {
          'Type': 'DDR4',
          'Configuration': 'Kit (2x8GB)',
          'Total Capacity': '16GB',
          'Speed': '3200MHz',
          'CAS Latency': 'CL16',
          'RGB': 'No',
          'XMP': 'Intel XMP Ready'
        }
      },
      {
        id: 'ram-3',
        name: 'CORSAIR VENGEANCE LPX 32GB Kit',
        priceUSD: 159.99,
        priceEUR: 136.87,
        supply: 7,
        imageUrl: '/images/ram/ram-3.avif',
        specs: {
          'Type': 'DDR4',
          'Configuration': 'Kit (2x16GB)',
          'Total Capacity': '32GB',
          'Speed': '3600MHz',
          'CAS Latency': 'CL18',
          'RGB': 'No',
          'XMP': 'Intel XMP 2.0'
        }
      },
      {
        id: 'ram-4',
        name: 'CORSAIR VENGEANCE LPX 32GB Kit',
        priceUSD: 174.99,
        priceEUR: 149.70,
        supply: 6,
        imageUrl: '/images/ram/ram-4.webp',
        specs: {
          'Type': 'DDR4',
          'Configuration': 'Kit (4x8GB)',
          'Total Capacity': '32GB',
          'Speed': '3200MHz',
          'CAS Latency': 'CL16',
          'RGB': 'No',
          'XMP': 'Intel XMP 2.0',
          'Quad Channel': 'Optimized'
        }
      }
    ],
    ddr5: [
      {
        id: 'ram-5',
        name: 'Kingston FURY Beast Black 16GB',
        priceUSD: 114.99,
        priceEUR: 98.37,
        supply: 13,
        imageUrl: '/images/ram/ram-5.webp',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Single (1x16GB)',
          'Total Capacity': '16GB',
          'Speed': '5600MHz',
          'CAS Latency': 'CL36',
          'RGB': 'No',
          'EXPO': 'AMD EXPO',
          'XMP': 'Intel XMP 3.0'
        }
      },
      {
        id: 'ram-6',
        name: 'CORSAIR VENGEANCE RGB 32GB Kit',
        priceUSD: 249.99,
        priceEUR: 213.87,
        supply: 5,
        imageUrl: '/images/ram/ram-6.avif',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Kit (2x16GB)',
          'Total Capacity': '32GB',
          'Speed': '6000MHz',
          'CAS Latency': 'CL36',
          'RGB': 'Yes (10-Zone RGB)',
          'XMP': 'Intel XMP 3.0',
          'iCUE Compatible': 'Yes'
        }
      },
      {
        id: 'ram-7',
        name: 'Patriot Xtreme 5 RGB 48GB Kit',
        priceUSD: 339.99,
        priceEUR: 290.86,
        supply: 4,
        imageUrl: '/images/ram/ram-7.webp',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Kit (2x24GB)',
          'Total Capacity': '48GB',
          'Speed': '6400MHz',
          'CAS Latency': 'CL32',
          'RGB': 'Yes (Viper RGB)',
          'XMP': 'Intel XMP 3.0',
          'EXPO': 'AMD EXPO'
        }
      },
      {
        id: 'ram-8',
        name: 'Kingston FURY Beast RGB 64GB Kit',
        priceUSD: 449.99,
        priceEUR: 384.97,
        supply: 5,
        imageUrl: '/images/ram/ram-8.jpg',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Kit (2x32GB)',
          'Total Capacity': '64GB',
          'Speed': '6000MHz',
          'CAS Latency': 'CL36',
          'RGB': 'Yes (Infrared Sync)',
          'XMP': 'Intel XMP 3.0'
        }
      },
      {
        id: 'ram-9',
        name: 'Kingston FURY Beast EXPO 64GB Kit',
        priceUSD: 439.99,
        priceEUR: 376.41,
        supply: 11,
        imageUrl: '/images/ram/ram-9.jpeg',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Kit (2x32GB)',
          'Total Capacity': '64GB',
          'Speed': '6000MHz',
          'CAS Latency': 'CL30',
          'RGB': 'No',
          'EXPO': 'AMD EXPO Certified',
          'XMP': 'Intel XMP 3.0'
        }
      },
      {
        id: 'ram-10',
        name: 'Kingston FURY Renegade 48GB',
        priceUSD: 369.99,
        priceEUR: 316.53,
        supply: 2,
        imageUrl: '/images/ram/ram-10.webp',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Single (1x48GB)',
          'Total Capacity': '48GB',
          'Speed': '6400MHz',
          'CAS Latency': 'CL32',
          'RGB': 'No',
          'EXPO': 'AMD EXPO',
          'XMP': 'Intel XMP 3.0'
        }
      },
      {
        id: 'ram-11',
        name: 'Kingston FURY Beast Black 64GB',
        priceUSD: 469.99,
        priceEUR: 402.08,
        supply: 8,
        imageUrl: '/images/ram/ram-11.webp',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Single (1x64GB)',
          'Total Capacity': '64GB',
          'Speed': '5600MHz',
          'CAS Latency': 'CL40',
          'RGB': 'No',
          'EXPO': 'AMD EXPO',
          'XMP': 'Intel XMP 3.0'
        }
      },
      {
        id: 'ram-12',
        name: 'CORSAIR VENGEANCE RGB 128GB Kit',
        priceUSD: 899.99,
        priceEUR: 769.94,
        supply: 7,
        imageUrl: '/images/ram/ram-12.avif',
        specs: {
          'Type': 'DDR5',
          'Configuration': 'Kit (2x64GB)',
          'Total Capacity': '128GB',
          'Speed': '5600MHz',
          'CAS Latency': 'CL40',
          'RGB': 'Yes (10-Zone RGB)',
          'XMP': 'Intel XMP 3.0',
          'iCUE Compatible': 'Yes'
        }
      }
    ]
  }
};
